// extracted by mini-css-extract-plugin
module.exports = {"animation":"style_animation__QL9ld"};